import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCostCenterTraffic from './ReportCostCenterTraffic'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCostCenterTraffic} />
    </Switch>
)

export default Components
